import {ChildEntity, Column} from "typeorm";
import {Competition} from ".";
import {Min} from "class-validator";

@ChildEntity()
export class CupCompetition extends Competition {
  @Column({type: 'integer', unsigned: true})
  @Min(1)
  rounds: number;

  @Column({type: 'boolean'})
  homeAndAway = true;

  @Column({type: 'boolean'})
  homeAndAwayFinal = false;
}
